<template>
  <div class="header-top">
    <div class="main">
      <div class="headinfo clearfix">
        <div class="headerinfo-fl fl">
          <div v-if="!isUser">
            <a href="javascript:void(0)" @click="addFavorite">
              <i v-show="!collect" class="iconfont icon-a-lujing157"></i>
              <i v-show="collect" class="iconfont icon-a-ziyuan1"></i>
              <i>收藏本站</i></a
            >
            <i class="headerinfo-i">|</i>
            <i>服务热线：187-4993-8350</i>
          </div>
          <div v-else>
            <!-- {{ langName }} -->
            <a href="supportself" v-if="backsy"
              ><i>{{ $t('home.return') }}</i></a
            >
            <i v-if="backsy" class="subfield">|</i>
            <a href="javascript:void(0)"
              ><i @click="loginOut" style="color: #7d818d">{{
                $t('home.quit')
              }}</i
              ><i style="color: #8b8c94; height: 12px" class="subfield">|</i>
            </a>
            <Dropdown translate transfer-class-name="DropdownDom">
              <a href="javascript:void(0)">
                <img
                  class="languageIcon"
                  src="../../../assets/Language.svg"
                  alt=""
                />
              </a>
              <template #list>
                <DropdownMenu @on-click="setLang('ch')">
                  <p
                    id="tags-p"
                    :class="langName == '简体中文' ? 'isDisabled' : ''"
                    @click="setLang('ch', langName == '简体中文')"
                  >
                    简体中文
                  </p>
                  <p
                    id="tags-p"
                    :class="langName == 'English' ? 'isDisabled' : ''"
                    @click="setLang('en', langName == 'English')"
                  >
                    English
                  </p>
                </DropdownMenu>
              </template>
            </Dropdown>
          </div>
        </div>
        <div class="headerinfo-fr fr">
          <div v-if="!isUser" class="w2">
            <a href="/login"> <i class="headerinfo-fr-a">请登录</i> </a>
            <i class="subfield">|</i>
            <a href="/register"><i class="register">注册</i></a>
            <!-- <i class="headerinfo-i">|</i>
            <a href="/login"> <i>免费登录</i> </a> -->
          </div>
          <div v-else>
            <ul>
              <li>
                <p @click="changeSore" class="w1">
                  {{ $t('home.welcome') }} {{ tenantInfo.tenantShortName }}
                </p>
                <a href="/personalData">({{ isUser.username }})</a>&nbsp;<i
                  class="headerinfo-i"
                  >|</i
                >
              </li>
              <!-- <li class="littlepei">
                <a href="https://msgapache.g-part.cn/download/">下载小佩</a>
                <i class="headerinfo-i">|</i>
              </li> -->
              <!-- <li>
                <router-link
                  class="btn shopcar"
                  rel="opener"
                  :to="{ path: '/attention' }"
                >
                  我的关注
                </router-link>
                <i class="headerinfo-i">|</i>
              </li> -->
              <li class="littlepei">
                <!-- <a href="">询报价 &nbsp;(<i>5</i>/<i>3</i>)</a> -->
                <router-link
                  class="btn shopcar"
                  rel="opener"
                  :to="{ path: '/askquote' }"
                >
                  {{ $t('home.quote') }} &nbsp;(<i>{{ enquirynum || 0 }}</i
                  >/<i>{{ quotenum || 0 }}</i
                  >)
                </router-link>
                <i class="headerinfo-i">|</i>
              </li>
              <li>
                <router-link
                  class="btn shopcar"
                  rel="opener"
                  :to="{ path: '/shoppingCart' }"
                >
                  {{ $t('home.cart') }} &nbsp;(<i>{{
                    shoppingCartCount || 0
                  }}</i
                  >/<i>{{ shoppingCartEnquiryCount || 0 }}</i
                  >)
                </router-link>
              </li>
              <i class="headerinfo-i">|</i>
              <!-- <li>
                <a href="javascript:void(0)"
                  >在线沟通 &nbsp;(<i>{{ number || 0 }}</i
                  >)</a
                >
                <a href="javascript:void(0)">
                  <xiaopei :oppositeTenantId="oppositeTenantId">
                    在线沟通
                  </xiaopei></a
                >
              </li> -->
              <!-- <i class="headerinfo-i">|</i> -->
              <li>
                <router-link
                  class="btn shopcar"
                  rel="opener"
                  :to="{ path: '/myweb' }"
                >
                  {{ $t('home.personal') }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-model="modal1"
      :title="$t('focus.Switch')"
      style="text-align: center"
      footer-hide
      :mask-closable="false"
    >
      <vxe-table
        :loading="loading"
        border
        show-header-overflow
        show-overflow
        align="center"
        :row-config="{ isHover: true }"
        :data="tableData"
        style="text-align: center"
      >
        <vxe-column field="operation" :title="$t('focus.operate')">
          <template #default="{ row }">
            <span
              v-show="row.switchable == 1"
              @click="changeBtn(row.tenantId)"
              style="color: #2d8cf0; cursor: pointer"
              >{{ $t('focus.to') }}
            </span>
          </template>
        </vxe-column>
        <vxe-column
          field="tenantName"
          :title="$t('focus.Company')"
          width="200"
        ></vxe-column>
        <vxe-column
          field="tenantShortName"
          :title="$t('focus.storeName')"
          width="120"
        ></vxe-column>
        <vxe-column field="roleNames" :title="$t('focus.Role')"></vxe-column>
      </vxe-table>
    </Modal>
  </div>
</template>

<script>
import { getCount, getTenant, getenquirysj } from '../../../api/home'
import { mapActions } from 'vuex'
// import xiaopei from '@/views/xiaopei/index.vue'
export default {
  name: 'header-top',
  data() {
    return {
      // isUser: this.$store.state.user.userData,
      isUser: JSON.parse(localStorage.getItem('userData')),
      tenantInfo: JSON.parse(localStorage.getItem('userdetails_tenantInfo')),
      shoppingCartCount: '', // 购物车
      shoppingCartEnquiryCount: '', // 购物车
      // number: '', // 在线沟通
      modal1: false,
      tableData: [],
      loading: false,
      oppositeTenantId: '',
      allattention: '', // 关注
      enquirynum: '', // 询价数量
      quotenum: '', //报价数量
      collect: false,
      backsy: false, // 返回首页
      langName: 'English'
    }
  },
  mounted() {
    console.log(localStorage.getItem('lang'),'localStorage.getItem()');
    this.langName = localStorage.getItem('lang')
  },
  methods: {
    setLang(lang, type) {
      if (type) {
        return
      }
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
      this.langName = this.getLangName(this.$i18n.locale)
      // 刷新页面
      // window.location.reload()
    },
    getLangName(lang) {
      if (lang === 'ch') {
        return '简体中文'
      } else if (lang === 'en') {
        return 'English'
      }
    },
    // 收藏
    addFavorite() {
      var url = window.location
      var title = document.title
      var ua = navigator.userAgent.toLowerCase()
      try {
        window.external.addFavorite(url, title)
        this.collect = true
      } catch (e) {
        try {
          window.sidebar.addPanel(title, url, '')
          this.collect = true
        } catch (e) {
          alert('收藏失败，此操作被浏览器拒绝！\n请使用Ctrl+D进行收藏！')
        }
      }
    },
    // 购物车
    async getCount() {
      if (this.isUser) {
        // console.log('11111')
        // const res = await getCount({ userId: this.isUser.id })
        const res = await getCount()
        if (res.status) {
          this.shoppingCartCount = res.data.shoppingCartCount
          this.shoppingCartEnquiryCount = res.data.shoppingCartEnquiryCount
        } else {
          // this.$Message.error(res.message)
        }
      } else {
        return
      }
    },
    ...mapActions(['handleLogOut']),
    // 退出
    loginOut() {
      const deviceId = localStorage.getItem('deviceId')
      var storage = window.localStorage
      storage.clear()
      this.handleLogOut({}).then(() => {
        this.$router.push({
          path: '/login'
        })

        console.log(deviceId)
        window.location.reload()
        localStorage.setItem('deviceId', deviceId)
      })
    },
    // 切换店铺
    changeSore() {
      this.modal1 = true
      this.loading = true
      this.tableData = this.tenantInfo.switchable
      this.loading = false
    },
    // 发请求
    async changeBtn(tenantId) {
      console.log(tenantId)
      this.loading = true
      const res = await getTenant({ tenantId })
      console.log(res)
      if (res.status) {
        if (res.data.tenantInfo.switchable.length > 0) {
          this.modal1 = false
          window.localStorage.userdetails_tenantInfo = JSON.stringify(
            res.data.tenantInfo
          )
          window.localStorage.userdetails_leagueInfo = JSON.stringify(
            res.data.leagueInfo
          )
          window.localStorage.staffName = JSON.stringify(res.data.staffName)

          let siderList = [] // 菜单数组
          let btnList = [] // 菜单数组
          res.data.resourceVOS.forEach((item) => {
            if (item.resourceType == 1) {
              siderList.push(item.name)
            } else if (item.resourceType == 2) {
              btnList.push(item.name)
            }
          })
          window.localStorage.siderList = JSON.stringify(siderList)
          window.localStorage.btnList = JSON.stringify(btnList)
          this.loading = false
          this.$router.push({
            path: '/'
          })
          window.location.reload()
        } else {
          this.loginOut()
        }
      }
      this.loading = false
    },
    // 询价数据
    async getenquirydata() {
      if (this.isUser) {
        const res = await getenquirysj()
        if (res.status) {
          this.enquirynum = res.data.enquiryNum
          this.quotenum = res.data.offerNum
        }
      } else {
        return
      }
    },
    xainshi() {
      if (this.$route.name != 'supportself' && this.$route.name!='home') {
        this.backsy = true
      } else {
        this.backsy = false
      }
    }
  },
  created() {
    this.xainshi()
    this.getCount()
    this.getenquirydata()
  }
  // components: {
  //   xiaopei
  // }
}
</script>

<style lang="less" scoped>
.header-top {
  position: fixed;
  top: 0;
  min-width: 1200px;
  background-color: #f2f2f5;
  width: 100%;
  height: 50px;
  font-size: 14px;
  z-index: 99;
  .clearfix {
    overflow: hidden;
    _zoom: 1;
  }
  .main {
    margin: 0 auto;
    width: 1200px;
    // width: 70%;
    height: 50px;
    line-height: 50px;
    color: #787878;
    .headinfo {
      display: flex;
      justify-content: space-between;
      a {
        color: #787878;
        font-size: 14px;
      }
      i {
        color: #787878;
        font-size: 14px;
      }
      a > i:hover {
        color: #377cf1;
      }
      .fl {
        // float: left;
      }
      .fr {
        // float: right;
      }
      .headerinfo-i {
        padding: 0 6px;
        color: #8b8c94;
      }
      .headerinfo-fl {
        .icon-a-lujing157 {
          margin-right: 4px;
        }
        .subfield {
          width: 1px;
          color: #8b8c94;
          margin: 0 8px;
        }
        .languageIcon {
          width: 18px;
          cursor: pointer;
          vertical-align: middle;
        }
      }
      .headerinfo-fr {
        width: 75%;
        // display: flex;
        // justify-content: space-between;
        .w2 {
          display: flex;
          justify-content: right;
        }
        .headerinfo-fr-a {
          color: #377cf1;
          font-size: 14px;
          font-weight: 400;
        }
        .subfield {
          width: 1px;
          color: #8b8c94;
          margin: 0 5px;
        }
        .register {
          color: #8b8c94;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          &:hover {
            color: #377cf1;
          }
        }
        ul {
          display: flex;
          // justify-content: space-between;
          justify-content: right;
          li {
            // width: 103px;
            display: flex;
            justify-content: space-between;
            // display: inline;
            list-style-type: none;
            a > i {
              color: #e90d0d;
            }
          }
        }

        ul > li > a:hover {
          color: #377cf1;
        }
        .w1 {
          // display: inline-block;
          // display: block;
          max-width: 256px;
          overflow: hidden;
          word-break: keep-all;
          white-space: nowrap;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        .w1:hover {
          color: #377cf1;
        }
      }
    }
  }
  .littlepei {
    // margin-left: 20px;
  }
  .blue377 {
    color: #377cf1;
  }
  .shouli {
    color: #2d8cf0;
    text-decoration: underline;
    cursor: pointer;
  }
}
.DropdownDom {
  width: 100%;
  #tags-p {
    cursor: pointer;
    height: 16px;
    font-size: 14px;
    font-weight: 400;
    color: #000;
  }
  #tags-p:nth-child(1) {
    margin: 0px 20px;
  }
  #tags-p:nth-child(2) {
    margin: 20px 20px 30px;
  }
  #tags-p:hover {
    // color: #0066ff;
  }
  .isDisabled {
    color: #c5c8ce !important;
    cursor: not-allowed !important;
  }
}
</style>
